export const chunk = <T extends any[]>(arr: T, size: number): T[] => {
  return arr.reduce((newArr, _, i) => (i % size ? newArr : [...newArr, arr.slice(i, i + size)]), [] as T[][]);
};
